<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading">
            <div v-if="listMode" class="row">
                <div class="col-md-12 col-sm-12">
                    <div class>
                        <div class="x_panel">
                            <h2 class="float-left">Critical Component Jobs Report</h2>
                            <ul class="nav navbar-right panel_toolbox align-right">
                                <li v-if="isPermissionExist(PERMISSIONS.CRITICAL_JOBS_REPORT_PRINT)">
                                    <button @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                                        <i class="fa fa-print" v-if="!isPrinting"></i>
                                        <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                                        {{ isPrinting ? 'Printing...' : 'Print' }}
                                    </button>
                                </li>
                              <li
                                v-if="isPermissionExist(PERMISSIONS.CRITICAL_JOBS_REPORT_PRINT)"
                              >
                                <vue-excel-xlsx
                                  ref="excel"
                                  :data="excelData"
                                  :columns="excelHeader"
                                  :file-name="'Critical Component Job List'"
                                  :file-type="'xlsx'"
                                  :sheet-name="'sheetname'"
                                  :disabled="isPrinting"
                                  class="btn btn-primary btn-sm float-right"
                                >
                                  <div
                                    @click.prevent="handleExportPrint('excel')"
                                  >
                                    <i class="fa fa-file-excel-o"></i>
                                    {{ isPrinting ? 'Preparing...' : 'Excel' }}
                                  </div>
                                </vue-excel-xlsx>
                              </li>
                                <li>
                                    <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                                </li>
                            </ul>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Department</label>
                                                    <select v-model="departmentId" name="department_id" class="form-control" @change="getMainComponent(departmentId)">
                                                        <option value selected>Select Department</option>
                                                        <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Main Component</label>
                                                    <select v-model="mainComponentId" name="main_component_id" class="form-control" @change="getComponentList(mainComponentId)">
                                                        <option value selected>Select Main Component</option>
                                                        <option v-for="mainComponent in mainComponents" :key="mainComponent.id" :value="mainComponent.id">{{ mainComponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Component</label>
                                                    <select v-model="componentId" name="component_id" class="form-control" @change="getSubComponent(componentId)">
                                                        <option value selected>Select component</option>
                                                        <option v-for="component in components" :key="component.id" :value="component.id">{{ component.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Sub Component</label>
                                                    <select v-model="subComponentId" name="component_id" class="form-control" @change="getSubSubComponent(subComponentId)">
                                                        <option value="" selected>Select Sub component</option>
                                                        <option v-for="subcomponent in subcomponents" :key="subcomponent.id" :value="subcomponent.id">{{ subcomponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label>Sub Sub Component </label>
                                                    <select v-model="subSubComponentId" name="component_id" class="form-control">
                                                        <option value="" selected>Select Sub Sub component</option>
                                                        <option v-for="subsubcomponent in subsubcomponents" :key="subsubcomponent.id" :value="subsubcomponent.id">{{ subsubcomponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Job Interval</label>
                                                    <select class="form-control" v-model="listType">
                                                        <option value>Select Job Interval</option>
                                                        <option value="Yearly">Yearly</option>
                                                        <option value="Two-Yearly">2 yearly</option>
                                                        <option value="Thirty-Monthly">2.5 yearly</option>
                                                        <option value="Three-Yearly">3 yearly</option>
                                                        <option value="Four-Yearly">4 yearly</option>
                                                        <option value="Five-Yearly">5 yearly</option>
                                                        <option value="Ten-Yearly">10 yearly</option>
                                                        <option value="Fifteen-Yearly">15 yearly</option>
                                                        <option value="Monthly">Monthly</option>
                                                        <option value="Three-Monthly">3 Monthly</option>
                                                        <option value="Six-Monthly">6 Monthly</option>
                                                        <option value="Weekly">Weekly</option>
                                                        <option value="Running Hours">Running Hour</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6 ">
                                                <div class="form-group">
                                                    <label for="">Search </label>
                                                    <input type="text" placeholder="Enter job name or code" v-model="searchInput" name="searchInput" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-1 mt-2">
                                                <div class="form-group">
                                                    <label for=""></label>
                                                    <button class=" mt-3 btn-info btn btn-sm" @click="getData()">Search</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12 ">
                                                <div class="justify-content-center">
                                                    <ul class="nav navbar-left  align-left">
                                                        <li>
                                                            <button @click="selectDepartment('')"
                                                                    :class="['btn btn-outline-info btn-sm', { active: '' === selectedDepartment }]"
                                                            > All <span class="badge badge-success"></span></button>
                                                        </li>
                                                        <li v-for="(department, index) in departmentWiseJob" :key="department.id">
                                                            <button @click="selectDepartment(department.id)"
                                                                    :class="['btn btn-outline-info btn-sm', { active: department.id === selectedDepartment }]"
                                                            > {{department?.name}}({{department?.code}}) <span class="badge badge-success">{{department?.job_count}}</span></button>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                                        <div class="card-box table-responsive">
                                            <p class="text-muted font-13 m-b-30"></p>
                                            <TableData :jobs="jobs?.data" :currentPage="Number(jobs?.current_page)" :perPage="Number(jobs?.per_page)"/>
                                            <Pagination :pagination="jobs" :getData="getData"/>
                                            <div id="printArea" style="display: none">
                                                <div style="text-align: center;line-height: 20px;">
                                                    <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                    <h4 style="line-height: 10px;">Vessel Name: {{ this.vessel_name }}</h4>
                                                    <div style="line-height: 10px;" class="font-weight-bold">Critical Component Job List</div>
                                                    <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                                </div>
                                                <TableData :jobs="printItems" :isPrinting="true"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    import DatePicker from 'vue2-datepicker'
    import QrcodeVue from 'qrcode.vue'
    import RunningHourJob from '@/components/Settings/RunningHourJob.vue'
    import {VueEditor} from 'vue2-editor'
    import 'vue2-datepicker/index.css'
    import auth from '../../../auth'
    import TableData from "./TableData.vue";
    import permissionsMixin from "@/mixin/permissionsMixin";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";

    export default {
        mixins: [permissionsMixin, printMixin, goBackButtonMixin],
        name: 'Job',
        components: {
            Pagination,
            TableData,
            DatePicker,
            QrcodeVue,
            VueEditor,
            RunningHourJob,
            PulseLoader
        },
        data() {
            return {
                loading: false,
                appName: process.env.VUE_APP_NAME,
                RunningReport: false,
                listMode: true,
                selectedJob: '',
                value: '',
                size: 200,
                offset: 20,
                listType: '',
                editMode: false,
                isPrinting: false,
                running_hours_value_type: false,
                user_type: auth.getUserType(),
                permissions: auth.getPermissionData(),
                query: '',
                queryFiled: 'name',
                types: [],
                departmentId: '',
                mainComponentId: '',
                isCriticalEquipment: '',
                departments: [],
                printItems: [],
                departmentWiseJob: [],
                selectedDepartment: '',
                mainComponents: [],
                components: [],
                subcomponents: [],
                subsubcomponents: [],
                componentId: '',
                subComponentId: '',
                subSubComponentId: '',
                searchInput: '',
                jobs: [],
                ranked: [],
                jobRunningHourForm: new Form({
                    isEnabled: false,
                    job_id: '',
                    prev_maintanance_running_hour: '',
                    schedule_hour: '',
                    current_running_hour_value: '',
                    start_date: '',
                }),
                form: new Form({
                    id: '',
                    name: '',
                    department_id: '',
                    main_component_id: '',
                    component_id: '',
                    sub_component_id: '0',
                    sub_sub_component_id: '0',
                    job_type_id: '',
                    job_duration_type: 'Yearly',
                    job_duration: '1',
                    manual_id: '',
                    code: '',
                    counter_type: '',
                    running_hours_value: '0',
                    running_schedule_value: '',
                    current_running_hours_value: 0,
                    start_date: '',
                    end_date: '',
                    instruction_manual: '',
                    rank_fixed: auth.getUserType(),
                    pw_ra_assign: 'Yes',
                    job_remarks: '',
                    status: 'Approved',
                    vessel_id: auth.getVesselId()
                }),
                vessel_id: auth.getVesselId(),
                vessel_name: auth.getVesselName(),
                pagination: {
                    current_page: 1,
                },
                excelHeader: [],
                excelData: [],
            }
        },
        mounted() {
            this.jobType();
            this.departmentList();
            this.getData();
            this.getAllRanked();
            this.getDepartmentWiseJob();
        },
        watch: {
            'form.department_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.departments);
                }
            },
            'form.main_component_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.mainComponents);
                }
            },
            'form.component_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.components);
                }
            },
            'form.sub_component_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.subcomponents);
                }
            },
            'form.sub_sub_component_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.subsubcomponents);
                }
            },
        },
        methods: {
            updateCode(itemId, components) {
                const selectedComponent = components.find(component => component.id === itemId);
                if (selectedComponent && selectedComponent.code) {
                    return selectedComponent.code + '-';
                }
                return '';
            },
            onPerPageChange() {
                this.getData(1);
            },

          prepareExportData(jobList) {
            let rows = [];
            if (!jobList || !jobList) return rows;

            jobList.forEach((job, index) => {
              rows.push({
                '#': index + 1,

                'Job Name(Code)': `${job?.name || ''} (${job?.code || ''})`,

                'Dept Name(Code)': `${job?.department?.name || ''} (${job?.department?.code || ''})`,

                'Component Name':
                  `${job?.main_component?.name || ''} >> ` +
                  `${job?.component?.name || ''}` +
                  (job?.sub_component ? ` >> ${job?.sub_component?.name}` : '') +
                  (job?.sub_sub_component ? ` >> ${job?.sub_sub_component?.name}` : ''),

                'Job Type': job?.job_type?.name || '',

                'Counter Type': job?.counter_type || '',

                'Start Date': job?.latestJobSchedule?.start_date
                  ? this.$moment(job.latestJobSchedule.start_date).format('DD-MM-YYYY')
                  : '',

                'End Date': job?.latestJobSchedule?.end_date
                  ? this.$moment(job.latestJobSchedule.end_date).format('DD-MM-YYYY')
                  : '',

                'Critical Equipment':
                  job?.main_component?.critical_equipment == 1 ||
                  job?.component?.critical_equipment == 1 ||
                  job?.sub_component?.critical_equipment == 1 ||
                  job?.sub_sub_component?.critical_equipment == 1
                    ? 'Yes'
                    : 'No',

                'Rank': job?.rank_fixed_role?.name || '',

                'Status': job?.status || ''
              });
            });


            return rows;
          },

          excelExport(jobList) {
            let data = this.prepareExportData(jobList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },
          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.vessel_id,
                counter_type: this.listType,
                department_id: this.selectedDepartment || this.departmentId,
                main_component_id: this.mainComponentId,
                component_id: this.componentId,
                sub_component_id: this.subComponentId,
                sub_sub_component_id: this.subSubComponentId,
                search: this.searchInput,
                is_critical_equipment: 'Yes',
                is_all: 1,
              };

              const res = await this.$http.get('/api/job', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Critical Job List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  this.isPrinting = false;
                  this.$refs.excel.$el.click();
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            getData(page = 1) {
                this.loading = true;
                const params = {
                    vessel_id: this.vessel_id,
                    counter_type: this.listType,
                    department_id: this.selectedDepartment || this.departmentId,
                    main_component_id: this.mainComponentId,
                    component_id: this.componentId,
                    sub_component_id: this.subComponentId,
                    sub_sub_component_id: this.subSubComponentId,
                    search: this.searchInput,
                    is_critical_equipment: 'Yes',
                    page: page,
                    is_all: 0,
                    offset: this.offset,
                };

                this.$http.get('/api/job', {params}).then((response) => {
                    this.jobs = response.data.success;
                    this.loading = false;
                }).catch((e) => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 422) {
                        if (response.data?.errors) {
                            const errors = response.data.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    } else if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        this.$snotify.error('Something went wrong')
                    }
                });
            },
            selectDepartment(departmentId) {
                if (this.selectedDepartment === departmentId) {
                    this.selectedDepartment = '';
                } else {
                    this.selectedDepartment = departmentId;
                }
                this.getData();
            },
            create() {
                this.editMode = false;
                this.form.reset();
                this.form.clear();
                $('#jobModal').modal('show')
            },
            store() {
                this.form.busy = true;
                this.form.post('/api/job').then((response) => {
                    this.getData();
                    this.getDepartmentWiseJob();
                    $('#jobModal').modal('hide');
                    $('#copyModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success('Job Successfully Saved')
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch((e) => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else if (response.status === 422) {
                        if (e.response.data?.errors) {
                            const errors = e.response.data?.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    } else {
                        this.$snotify.error(response?.data?.error)
                    }
                })
            },
            edit(job) {
                let self = this;
                this.editMode = true;
                self.getMainComponent(job.department_id);
                self.getComponentList(job.main_component_id);
                self.getSubComponent(job.component_id);
                self.getSubSubComponent(job.sub_component_id);
                self.form.fill(job);
                setTimeout(function () {
                    self.form.code = job.code;
                }, 1500);

                $('#jobModal').modal('show');
            },
            update() {
                this.form.busy = true;
                this.form._method = 'put';
                this.departmentList();
                this.form.post('/api/job/' + this.form.id).then((response) => {
                    this.getData();
                    this.getDepartmentWiseJob();
                    $('#jobModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success('Job Successfully Updated', 'Success')
                    } else {
                        this.$snotify.error('Something went wrong try again later.', 'Error')
                    }
                }).catch((e) => {
                    console.log(e)
                })
            },
            show(job) {
                let self = this;
                self.form.reset();
                self.form.fill(job);
                setTimeout(function () {
                    self.form.code = job?.code;
                }, 500);
                $('#showModal').modal('show')
            },
            runningHourUpdate(job) {
                this.jobRunningHourForm.job_id = job.id;
                this.jobRunningHourForm.prev_maintanance_running_hour = job.running_hours_value;
                this.jobRunningHourForm.schedule_hour = job.running_schedule_value;
                this.jobRunningHourForm.current_running_hour_value = job.current_running_hours_value;
                $('#runningHourUpdate').modal('show');
            },
            jobRunningHourUpdate() {
                this.jobRunningHourForm.busy = true;
                this.jobRunningHourForm.post('/api/running-hour-update').then((response) => {
                    $('#runningHourUpdate').modal('hide');
                    if (this.jobRunningHourForm.successful) {
                        this.$snotify.success('Running Hour Update Successfully');
                        this.getData();
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch((e) => {
                    var error = this.jobRunningHourForm.errors.errors.error;
                    this.$snotify.error(error)
                })
            },
            destroy(data) {
                this.$dialog.confirm('Do You Want to delete This ?').then(() => {
                    this.$http.delete('/api/job/' + data.id).then((response) => {
                        this.getData()
                        this.getDepartmentWiseJob();
                        this.$snotify.success('Job Successfully Deleted')
                    })
                        .catch((e) => {
                            this.$snotify.error('Job Not Deleted')
                        })
                }).catch(function () {
                })
            },
            jobType() {
                this.$http.get('/api/filter/job-type/' + this.vessel_id).then((response) => {
                    this.types = response.data.success;
                }).catch((e) => {
                    console.log(e)
                });
            },
            getDepartmentWiseJob() {
                let params = {
                    is_critical_equipment: 1,
                }
                this.$http.get('/api/filter/get-department-wise-job/' + this.vessel_id, {params}).then((response) => {
                    this.departmentWiseJob = response.data.success;
                }).catch((e) => {
                    console.log(e)
                });
            },

            departmentList() {
                this.$http.get('/api/filter/get-active-department/' + this.vessel_id).then((response) => {
                    this.departments = response.data.success;
                }).catch((e) => {
                    console.log(e)
                });
            },
            getMainComponent(department_id) {

                this.mainComponents = [];
                this.components = [];
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.form.main_component_id = '';
                this.form.component_id = '';
                this.form.sub_component_id = '0';
                this.form.sub_sub_component_id = '0';
                this.mainComponentId = '';
                this.componentId = '';
                this.subComponentId = '';
                this.subSubComponentId = '';
                let params = {
                    is_all: 1
                }
                if (department_id !== '') {
                    this.$http.get('/api/filter/main-component/' + this.vessel_id + '/' + department_id, {params}).then((response) => {
                        this.mainComponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getComponentList(main_component_id) {
                this.components = [];
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.form.component_id = '';
                this.form.sub_component_id = '0';
                this.form.sub_sub_component_id = '0';
                this.componentId = '';
                this.subComponentId = '';
                this.subSubComponentId = '';
                let params = {
                    is_all: 1
                }
                if (main_component_id !== '') {
                    this.$http.get('/api/filter/component/' + this.vessel_id + '/' + main_component_id, {params}).then((response) => {
                        this.components = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getSubComponent(component_id) {
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.form.sub_component_id = '0';
                this.form.sub_sub_component_id = '0';
                this.subComponentId = '';
                this.subSubComponentId = '';
                let params = {
                    is_all: 1
                }
                if (component_id != '0') {
                    this.$http.get('/api/filter/sub-component/' + this.vessel_id + '/' + component_id, {params}).then((response) => {
                        this.subcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getSubSubComponent(sub_component_id) {
                this.subsubcomponents = []
                this.form.sub_sub_component_id = '0';
                this.subSubComponentId = '';
                let params = {
                    is_all: 1
                }
                if (sub_component_id != '0') {
                    this.$http.get('/api/filter/sub-sub-component/' + this.vessel_id + '/' + sub_component_id, {params}).then((response) => {
                        this.subsubcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            previewFiles(event) {
                var file = event.target.files[0];
                this.form.instruction_manual = file;
            },
            getAllRanked() {
                this.$http.get('/api/role').then((response) => {
                    this.ranked = response.data.success;
                }).catch((e) => {
                    console.log(e)
                });
            },
            clearRankedFixed() {
                if (this.form.rank_fixed != '') {
                    this.form.rank_variable = ''
                }
            },
            //store item to component data
            showQRCode(job) {
                this.value = job.id.toString();
                $('#componenttModel').modal('show');
            },
            //approved pending job
            approvedJob(job) {
                this.$http.get('/api/job-approved/' + job.id).then((response) => {
                    this.getData();
                    this.$snotify.success('Job Successfully Approved ')
                }).catch((e) => {
                    this.$snotify.error('Job  Approved Can not be Successfull')
                })
            },

            /*runningHourUpdate (job) {
              // if(job.job_schedules[i].permit_to_work==null && job.job_schedules[i].risk_assessment!=null){
              if (job != null) {
                this.selectedJob = job
                this.RunningReport = true
                this.listMode = false
              } else {
                this.RunningReport = false
                this.listMode = true
              }
            },*/

            changeListMode() {
                this.RunningReport = false;
                this.listMode = true;
                this.jobType();
                this.departmentList();
                this.getData();
                this.getAllRanked();
            },

        },
    }
</script>

<style>
    .mx-datepicker-popup {
        z-index: 9000 !important;
    }

    .des {
        height: 36% !important;
    }
</style>
